import { Swiper } from 'swiper/bundle'
import * as factory from '../../../iawp/src/js/factory'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'
import { DotLottie } from '@lottiefiles/dotlottie-web';
import './accessibility/accessibility.js'

var animationCookie = true;
let dotLottie = '';
let dotLottieMobile = '';

if(!!document.querySelector('.home')) {
    let animationUrl = (document.querySelector('html').classList.contains('dark-mode'))?'/wp-content/themes/iawp-child/assets/img/schedule.json':'/wp-content/themes/iawp-child/assets/img/schedule_light.json';
    let animationUrlMobile = (document.querySelector('html').classList.contains('dark-mode'))?'/wp-content/themes/iawp-child/assets/img/schedule_mobile.json':'/wp-content/themes/iawp-child/assets/img/schedule_light_mobile.json';
    if(sessionStorage['animationCookie'] != 'true'){
        document.querySelector('html').classList.add('no-scroll')
        dotLottie = new DotLottie({
            autoplay: true,
            loop: false,
            canvas: document.querySelector('#dotlottie-canvas'),
            src: animationUrl,
            useFrameInterpolation: true,
        });
        
        dotLottie.addEventListener('complete', e => {
            setTimeout(() => {
                document.querySelector('.home').classList.add('animated')
                document.querySelector('html').classList.remove('no-scroll')
                sessionStorage['animationCookie'] = animationCookie;
            }, 500);
        });
        dotLottieMobile = new DotLottie({
            autoplay: true,
            loop: false,
            canvas: document.querySelector('#dotlottie-canvas-mobile'),
            src: animationUrlMobile,
            useFrameInterpolation: true,
        });
        
        dotLottieMobile.addEventListener('complete', e => {
            setTimeout(() => {
                document.querySelector('.home').classList.add('animated')
                document.querySelector('html').classList.remove('no-scroll')
                sessionStorage['animationCookie'] = animationCookie;
            }, 500);
        });
    }else{
        document.querySelector('.home').classList.add('animated')
        dotLottie = new DotLottie({
            autoplay: false,
            loop: false,
            canvas: document.querySelector('#dotlottie-canvas'),
            src: animationUrl,
            segment: [599, 599],
            useFrameInterpolation: true,
        });
        dotLottieMobile = new DotLottie({
            autoplay: false,
            loop: false,
            canvas: document.querySelector('#dotlottie-canvas-mobile'),
            src: animationUrlMobile,
            segment: [419, 419],
            useFrameInterpolation: true,
        });
    }
}

if(window.location.href.indexOf('#') > -1){
    setTimeout(() => {
        var $header = factory.$('.section-header')
        var target = "#"+window.location.href.split('#')[1];
        factory.$('.is-style-list-anchor li a').attr('data-active','')
        factory.$('.is-style-list-anchor li a').attr('aria-current','')
        
        if (target !== undefined && target.length > 0 && target[0] === '#') {
            factory.$(this).attr('data-active','anchor-active')
            factory.$(this).attr('aria-current','true')
            factory.$('html, body').animate({
                scrollTop: factory.$(target).offset().top - ($header.outerHeight() + 100)
            }, 1000);
        }
        history.replaceState(null, null, ' ');
    }, 200);
}

new factory.IAInit()
openMobileSubmenu('<i class="fa-solid fa-chevron-down"></i>', '<i class="fa-solid fa-chevron-up"></i>')
document.querySelectorAll('.open-menu-btn').forEach(subMenu => {
    subMenu.addEventListener('click', button => {
        (subMenu.classList.contains('active'))?subMenu.parentElement.parentElement.classList.add('current-menu-item'):subMenu.parentElement.parentElement.classList.remove('current-menu-item')
    })
})

// Manage dark theme toggle
function disableDarkTheme() {
    document.querySelector('html').classList.remove('dark-mode')
    document.querySelector('html').classList.add('light-mode')
    document.cookie = 'dark-theme=false; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
    document.querySelector('.ia-block-themes-selector input').removeAttribute('aria-checked')
}

function enableDarkTheme() {
    console.log(document.querySelector('html'), 'hello dark theme')
    document.querySelector('html').classList.remove('light-mode')
    document.querySelector('html').classList.add('dark-mode')
    document.querySelector('.ia-block-themes-selector input').setAttribute('aria-checked', 'true')
    document.cookie = 'dark-theme=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
}

if (document.cookie.split(";").some((item) => item.trim().startsWith('dark-theme=true'))) {
	// If the user has the dark mode cookie, respect the cookie.
	enableDarkTheme();
} else if (document.cookie.split(";").some((item) => item.trim().startsWith('dark-theme=false'))) {
	// If the user has the light mode cookie, respect the cookie.
	disableDarkTheme();
} else {
	if (
		window.matchMedia 
		&& (
			window.matchMedia("(prefers-color-scheme: dark)").matches 
		)
	) {
		// If the user prefers dark mode, enable dark mode.
		enableDarkTheme();
	} else {
		// User prefers light mode via system preferences.
		disableDarkTheme();
	}
}

if (!!document.querySelector('.ia-block-themes-selector #brand')) {
    document.querySelector('.ia-block-themes-selector #brand').addEventListener('click', e => {
        let needDarkTheme = e.currentTarget.checked
        if (needDarkTheme) {
            enableDarkTheme()
        } else {
            disableDarkTheme()
        }

        if(!!document.querySelector('.home')){
            let animationUrl = (document.querySelector('html').classList.contains('dark-mode'))?'/wp-content/themes/iawp-child/assets/img/schedule.json':'/wp-content/themes/iawp-child/assets/img/schedule_light.json';
            let animationUrlMobile = (document.querySelector('html').classList.contains('dark-mode'))?'/wp-content/themes/iawp-child/assets/img/schedule_mobile.json':'/wp-content/themes/iawp-child/assets/img/schedule_light_mobile.json';
            if(dotLottie != ""){
                dotLottie.destroy()
                dotLottie = new DotLottie({
                    autoplay: false,
                    loop: false,
                    canvas: document.querySelector('#dotlottie-canvas'),
                    src: animationUrl,
                    segment: [599, 599],
                    useFrameInterpolation: true,
                });
            }
            
            if(dotLottieMobile != ""){
                dotLottieMobile.destroy()
                dotLottieMobile = new DotLottie({
                    autoplay: false,
                    loop: false,
                    canvas: document.querySelector('#dotlottie-canvas-mobile'),
                    src: animationUrlMobile,
                    segment: [419, 419],
                    useFrameInterpolation: true,
                });
            }
        }
    })
}

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content') 
    )
})

// Swiper sliders initialisation
document.querySelectorAll('.swiper-container:not(.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        itemPerSlide: 1, // 2 items per view on desktop, 1 on mobile
        autoplay: 2000 // change slide every 2 seconds
    })
})

document.querySelectorAll('.swiper-container.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        fullwidth: true,
        paginationElement: '.swiper-pagination',
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 4
            }
        }
    })
})

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}

if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
}

if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}

if(!!document.querySelectorAll('.ia-block-latest-post .load-more')){
    document.querySelectorAll('.ia-block-latest-post .load-more').forEach(newsButton => {
        newsButton.addEventListener('click', (e)=>{
            new factory.IALoadMore().addLoader(newsButton)
        })
    })
}

if(!!document.querySelectorAll('.ia-block-list-faq')){
    document.querySelectorAll('.ia-block-list-faq__item').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-list-faq__item__dropdown'), 
            dropdown.querySelector('.dropdown-content') 
        )
    })
}

if (!!document.querySelector('.ia-block-partners__slider.swiper')) {
    document.querySelectorAll('.ia-block-partners__slider.swiper').forEach(block => {
        let swiper = new Swiper(block, {
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 73.5
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 73.5
                }
            },
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: block.querySelector('.swiper-pagination'),
                clickable: true,
                renderBullet: function (index, className) {
                    return '<button class="' + className + '"></button>';
                }
            },
        })
    })
}

if (!!document.querySelector('.footer-section.js-collapse-on-mobile')) {
    function footerMenus(mq) {
        const footerSections = document.querySelectorAll('.footer-section.js-collapse-on-mobile');
        
        footerSections.forEach(section => {
            const menus = section.querySelectorAll('.footer-section-menu');
            const titles = section.querySelectorAll('.footer-section-title');

            if (mq.matches) {
                menus.forEach(menu => menu.style.display = 'none');
                
                titles.forEach(title => {
                    title.addEventListener('click', function() {
                        const nav = this.nextElementSibling;
                        if (nav.style.display === 'none' || nav.style.display === '') {
                            nav.style.display = 'flex';
                        } else {
                            nav.style.display = 'none';
                        }
                    });
                });
            } else {
                titles.forEach(title => {
                    title.replaceWith(title.cloneNode(true)); // Remove all event listeners
                });
                menus.forEach(menu => menu.style.display = 'flex');
            }
        });
    }

    let footerMenusMQ = window.matchMedia("(max-width: 1024px)");
    footerMenus(footerMenusMQ);
    footerMenusMQ.addEventListener('change', () => footerMenus(footerMenusMQ));
}

factory.$(document).on('click', '.ia-block-news-filter button', function(event) {
    var value = factory.$(this).val();
    var baseUrl = window.location.origin + window.location.pathname;
    var newUrl = baseUrl;
    
    if (value !== '') {
        newUrl += '?catObject[0]=' + value + '&paged=1';
    } else {
        newUrl += '?paged=1'; //Reset to page 1
    }
    
    window.location.href = newUrl;
});

factory.$(document).on('click','a[href^="#"]', function(event) {
    var $header = factory.$('.section-header')
    var target = factory.$(this).attr('href');
    factory.$('.is-style-list-anchor li a').attr('data-active','')
    factory.$('.is-style-list-anchor li a').attr('aria-current','')
    
    if (target !== undefined && target.length > 0 && target[0] === '#') {
        factory.$(this).attr('data-active','anchor-active')
        factory.$(this).attr('aria-current','true')
        factory.$('html, body').animate({
            scrollTop: factory.$(target).offset().top - ($header.outerHeight() + 100)
        }, 1000);
    }
});

onresize = (event) => {
    if(!!document.querySelector('.home')){
        let animationUrl = (document.querySelector('html').classList.contains('dark-mode'))?'/wp-content/themes/iawp-child/assets/img/schedule.json':'/wp-content/themes/iawp-child/assets/img/schedule_light.json';
        let animationUrlMobile = (document.querySelector('html').classList.contains('dark-mode'))?'/wp-content/themes/iawp-child/assets/img/schedule_mobile.json':'/wp-content/themes/iawp-child/assets/img/schedule_light_mobile.json';
        if(dotLottie != ""){
            dotLottie.resize()
        }
        
        if(dotLottieMobile != ""){
            dotLottieMobile.resize()
        }
    }
};